import { alpha, Box, Hidden, makeStyles } from "@material-ui/core";
import DesktopHeader from "./screen/DesktopHeader";
import MobileHeader from "./screen/MobileHeader";
import TabletHeader from "./screen/TabletHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    background: theme.palette.background.paper,
    zIndex: 1205,
    width: "100%",
    height: 55,
    borderBottom: `1px solid ${alpha(theme.mode === "dark" ? "#fff" : "#000", 0.12)}`,
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
}));

export default function Header() {
  const cls = useStyles();

  return (
    <Box className={cls.root}>
      <Hidden smDown>
        <DesktopHeader />
      </Hidden>
      <Hidden mdUp xsDown>
        <TabletHeader />
      </Hidden>
      <Hidden smUp>
        <MobileHeader />
      </Hidden>
    </Box>
  );
}
